import React, { memo, useState } from 'react';
import { AdvanceFilter, Button, Table, Text } from 'components/src';
import {
  routesName,
  useDateChange,
  useGetAuthorityFindRoles,
  useNavigation,
} from 'core';
import { useTranslation } from 'react-i18next';
import {
  Flex,
  Space,
  Switch,
  TablePaginationConfig,
  Typography,
} from 'antd';
import { FilterOutlined, PlusOutlined } from '@ant-design/icons';
import { RiDeleteBin6Line, RiFileExcel2Line } from 'react-icons/ri';
import { IoCheckmarkDoneSharp } from 'react-icons/io5';
import {
  MdOutlineAddIcCall,
  MdOutlineRemoveDone,
} from 'react-icons/md';
import { CiEdit } from 'react-icons/ci';
import { PiNotebookLight } from 'react-icons/pi';

interface Props {}

const CallsReport = memo<Props>(() => {
  const { _navigate, _navigateWithParams } = useNavigation();
  const { i18n } = useTranslation();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>(
    []
  );
  const { changeDateToPersian } = useDateChange();
  {
    console.log(changeDateToPersian('1900/05/01 13:11'));
  }
  //   const { data: { data } = {}, isFetching } = useGetUserFindContacts();
  const columns: any = [
    {
      title: i18n.t('id'),
      key: 'id',
      dataIndex: 'id',

      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('firstUser'),
      dataIndex: 'firstUser',
      key: 'firstUser',
      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('secondUser'),
      dataIndex: 'secondUser',
      key: 'secondUser',
      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('callResult'),
      dataIndex: 'callResult',
      key: 'callResult',
      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('duration'),
      dataIndex: 'duration',
      key: 'duration',
      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('operation'),
      key: 'operation',
      dataIndex: 'operation',
      render: (_: any, record: any) => (
        <Flex align="center" justify="start">
          <Space>
            <Button
              title={i18n.t('details')}
              customColor="warning"
              onClick={() => {
                _navigateWithParams(routesName.DASHBOARD, {
                  id: record.id,
                });
              }}
            >
              <PiNotebookLight size={20} />
            </Button>
            <Button
              title={i18n.t('edit')}
              onClick={() => {
                _navigateWithParams(routesName.EDITUSER, {
                  id: record.id,
                });
              }}
            >
              <CiEdit size={20} />
            </Button>

            <Switch
              checked={record.is_active}
              onChange={
                () => {}
                // update({
                //   campaign: record.id,
                //   requestBody: {},
                // })
              }
              checkedChildren={
                <Space style={{ marginTop: 3 }}>
                  <MdOutlineRemoveDone size={15} />
                </Space>
              }
              unCheckedChildren={
                <Space>
                  <IoCheckmarkDoneSharp size={15} />
                </Space>
              }
            />
            <Button
              title={i18n.t('addNumber')}
              customColor="warning"
              onClick={() => {
                _navigateWithParams(routesName.DASHBOARD, {
                  id: record.id,
                });
              }}
            >
              <MdOutlineAddIcCall size={20} />
            </Button>
            <Button
              title={i18n.t('delete')}
              customColor="danger"
              onClick={() => {
                // dispatch(handleModal(true));
                // dispatch(setId(record.id));
              }}
              //   disabled={isPending}
            >
              <RiDeleteBin6Line size={20} />
            </Button>
          </Space>
        </Flex>
      ),
    },
  ];

  const onAdvanceFilterChange = (filterValues: any) => {
    // dispatch(handleFiltering(filterValues));
  };

  const handlePageChange = (current_page: number) => {
    // dispatch(updateCurrentPage(current_page));
  };

  const pagination: TablePaginationConfig = {
    // current: data?.meta?.current_page,
    // pageSize: data?.meta?.per_page,
    // total: data?.meta?.total,
    // onChange: handlePageChange,
    // showSizeChanger: false,
    // position: ["bottomRight"],
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  //   const isLoading = isFetching;
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <>
      <Table
        rowSelection={rowSelection}
        // filterComponent={
        //   <AdvanceFilter
        //     setAdvanceFilter={onAdvanceFilterChange}
        //     nameField={true}
        //     activeField={true}
        //     creatorField={true}
        //     serverField={true}
        //   />
        // }
        // loading={isLoading}
        // excelIcon={
        //   <Button
        //     title={i18n.t('downloadCampaigns')}
        //     isLoading={isCampaignNumberStatisticLoading}
        //     onClick={handleDownload}
        //   >
        //     <RiFileExcel2Line
        //       size={25}
        //       color={colors.green01}
        //       onClick={handleDownload}
        //       title={i18n.t('stats')}
        //     />
        //   </Button>
        // }
        {...{ columns }}
        // dataSource={data?.data}
        // pagination={pagination}
      ></Table>
    </>
  );
});
export { CallsReport };
